import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import get from 'lodash.get';

import { AppState } from 'services/types';
import { CalibrationId } from 'services/equipmentSets/types';
import { SprayWorksheetEntity } from 'services/worksheet/types';
import { OwnProps } from './index';
import { selectSprayWorksheetCalibrationsKeyedById } from '../../selectors';

const selectCalibrationId = (state: AppState, props: OwnProps): CalibrationId =>
    props.calibrationId;

const selectCalibrationsEntities = createDeepEqualSelector(
    selectSprayWorksheetCalibrationsKeyedById,
    selectCalibrationId,
    (calibrations, calibrationId) => {
        const entities = get(calibrations, [calibrationId, 'entities']);

        const entityNames = entities.reduce(
            (acc: string[], cur: SprayWorksheetEntity) => {
                const entityName = get(cur, 'name');

                if (entityName && !acc.includes(entityName)) {
                    acc.push(entityName);
                }

                return acc;
            },
            []
        );

        return entityNames.join(', ');
    }
);

const makeSelectCalibrationsEntities = (): typeof selectCalibrationsEntities =>
    selectCalibrationsEntities;

export { selectCalibrationId, makeSelectCalibrationsEntities };
